import React, { createContext, useEffect, useState } from "react";

export const CacheContext = createContext<any>({
  cache:null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCache: (value: any) => {},
});

// Parses the persisted cache, discarding it if it is no longer valid JSON
// (e.g. corrupted or truncated by a previous session/version).
export const readPersistedCache = (cacheData: string): Array<any> | null => {
  try {
    return JSON.parse(cacheData);
  } catch {
    localStorage.setItem("cacheData", "");
    return null;
  }
};

export const CacheContextProvider = (props: any) => {
  useEffect(() => {
    const cacheData = localStorage.getItem("cacheData");
    const parsedCache = cacheData && cacheData !== "" ? readPersistedCache(cacheData) : null;
    if (parsedCache) {
      setCache(parsedCache);
    }
    // No persisted cache yet (e.g. the login-time bootstrap request failed)
    // is a recoverable state, not a sign of corruption: NotificationsContextProvider
    // retries the fetch independently once mounted. Do not clear the token
    // or force a reload here — that would silently sign the user back out.
  }, [localStorage]);

  const setCache = (cache: Array<any>) => {
    localStorage.setItem("cacheData", JSON.stringify(cache));
    setState({ ...state, cache: cache });
    
  };
  const initState = {
    cache: new Array<any>(),
    setCache: setCache,
  };
  const [state, setState] = useState(initState);
  return (
    <CacheContext.Provider value={state}>
      {props.children}
    </CacheContext.Provider>
  );
};
